"use client";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { ProductCardRedesignTestResult } from "@/monarch/rules/productCardRedesign/types";
import { ProductCardProps } from "../types";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import { ClientSideProductCard } from "..";
import { Skeleton } from "@/components/ui/skeleton";

export default function ProductCardWrapper(props: ProductCardProps) {
  return (
    <ClientOnly>
      {/* TODO: We're reviewing the Monarch experiment, so we're not using it for now */}
      {/* <MonarchResolver<ProductCardRedesignTestResult>
        experimentKey="useProductCardRedesign"
        variants={{
          control: <ClientSideProductCard {...props} />,
          test: <ClientSideProductCard {...props} />, // TODO: When the redesign component is created we can render it here
        }}
        fallbackVariant="control"
        Loader={<Skeleton variant="productCard" />}
      /> */}
      <ClientSideProductCard {...props} />
    </ClientOnly>
  );
}
